<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2024-01-02 15:40:08
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-22 14:51:57
-->
<template>
    <div class="gap-2 grid-cols-2 w-full justify-between grid text-grey-40">
        <div class="flex flex-col bg-background-80 py-[7px] px-[10px] rounded-lg items-center justify-around col-span-1">
            <div class="text-grey-40 text-xs font-medium mb-[5px]">
                {{t.Bet}}
            </div>
            <div class="inline-flex text-sm gap-1">
                <CurrentCoin :name="history.currency" />
                <div>
                    <CasinoWidgetColoredAmount
                        class="font-semibold"
                        :colors="['#fff', 'rgb(85,101,126)']"
                        :amount="bPharaoBonusGame? Number(getFixed(history['bonusGameAmount'])) : Number(getFixed(history.amount))" 
                    ></CasinoWidgetColoredAmount>
                </div>
            </div>
        </div>
        <div class="flex flex-col bg-background-80 py-[7px] px-[10px] rounded-lg items-center justify-around col-span-1">
            <div class="text-grey-40 text-xs font-medium mb-[5px]">
                {{ t.Multiplier }}
            </div>
            <!-- ↓ 这里的倍数保留了2位，原版即保留了2位。2024.04.30 10:16:35 星期二  -->
            <div class="inline-flex text-sm font-semibold"
                :class="[history.winAmount ? 'text-[#1BB83D]' : 'text-white']"
            >
                x{{ getFixed(Number(history?.multi)) }}
            </div>
        </div>
        <!-- ↓ pharaoh 游戏专用  -->
        <div v-if="bPharaoBonusGame"
            class="flex flex-col bg-background-80 py-[7px] px-[10px] rounded-lg items-center justify-around col-span-1"
        >
            <div class="text-grey-40 text-xs font-medium mb-[5px]">
                {{ $t('pharaoh.BuyBonusPrice') }}
            </div>
            <div class="inline-flex text-sm gap-1">
                <CurrentCoin :name="history.currency" />
                <div>
                    <CasinoWidgetColoredAmount
                        class="font-semibold"
                        :colors="['#fff', 'rgb(85,101,126)']"
                        :amount="Number(getFixed(history.amount))" 
                    ></CasinoWidgetColoredAmount>
                </div>
            </div>
        </div>
        <!-- ↑ pharaoh 游戏专用  -->
        <div class="flex flex-col bg-background-80 py-[7px] px-[10px] rounded-lg items-center justify-around"
            :class="{
                'col-span-1': bPharaoBonusGame,
                'col-span-2': !bPharaoBonusGame,
            }"
        >
            <div class="text-grey-40 text-xs font-medium mb-[5px]">
                {{ t.winningAmount }}
            </div>
            <div class="inline-flex text-sm ">
                <div class="inline-flex gap-1">
                    <CurrentCoin :name="history.currency" />
                    <CasinoWidgetColoredAmount
                        class="font-semibold"
                        :colors="[history.winAmount ? '#1BB83D' : '#fff', 'rgb(85,101,126)']"
                        :amount="Number(getFixed(history.winAmount))" 
                    ></CasinoWidgetColoredAmount>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
    },
});

const t = useTranslation();

// ↓ pharaoh 游戏专用，表示是用户是否买了特奖 
const bPharaoBonusGame = computed(()=>{
    const {history} = props;
    const bResult = (
        history['bonusGameAmount'] > 0
        && history.game?.id === 12 // pharaoh
    ); 
    return bResult;
});



</script>
